import {Link} from 'react-router-dom';
import {useCurrentUser} from '../../context/CurrentUserContext';
import {getDefaultRouteForRole} from '../../utils/routeAccess';

const isOnDashboard = (path: string): boolean => path === '/dashboard' || path.startsWith('/dashboard/');

/**
 * YOJO-3434 [care-portal: any address the app does not know blanks the whole screen, no catch-all route]:
 * shown inside the normal shell (sidebar + header) for any signed-in address the route table does not know,
 * e.g. an old bookmark of a removed tab or a typo. Plain on purpose; designs come later.
 *
 * The home link goes to the user's own start page (the one Login falls back to), which is not the dashboard
 * for every role: a sales-only user has none and starts on Partner Enquiries.
 */
export default function NotFound() {
  const {roles} = useCurrentUser();
  const home = getDefaultRouteForRole(roles);

  return (
    <div data-testid="not-found" className="py-10">
      <h1 className="text-2xl font-semibold text-gray-900">This page doesn&apos;t exist</h1>
      <p className="mt-2 text-sm text-gray-600">The address may be old or mistyped.</p>
      <Link
        to={home}
        data-testid="not-found-home"
        className="mt-6 inline-block text-sm font-medium text-blue-600 hover:text-blue-500"
      >
        {isOnDashboard(home) ? 'Go to the dashboard' : 'Go to your start page'}
      </Link>
    </div>
  );
}
